<template lang="pug">
v-form.form(ref="form")
	v-card.px-5.primary--text.rounded-xxl
		v-img.mx-auto.pb-12(contain, width="185", :src="logo")
		h2.text-center.mb-4 {{ $t('Project.common.loginTitle') }}
		v-text-field.pa-2(
			v-model="userEmail"
			rounded
			dense
			single-line
			hide-details
			style="border: 1.5px solid grey;"
			:label="$t('Project.common.mailAddress')"
			type="mail"
			color="secondary"
			prepend-icon="mdi-account"
			clearable
			:rules=`[
				$store.state.regexp.required,
				$store.state.regexp.mail,
			]`
			@keydown.enter="submit()"
		).mb-5
		v-text-field.pa-2(
			v-model="userPassword"
			:label="$t('Project.common.password')"
			color="secondary"
			prepend-icon="mdi-key"
			rounded
			dense
			single-line
			hide-details
			style="border: 1.5px solid grey;"
			:type="passwordVisible ? 'text' : 'password'"
			:append-outer-icon="passwordVisible ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
			@click:append-outer="passwordVisible = !passwordVisible"
			:rules=`[
				$store.state.regexp.required,
			]`,
			@keydown.enter="submit()"
		).mb-7
		v-card-actions
			//- router-link(to="/forgot") Passwort vergessen?
			v-spacer
			//- v-btn(depressed color="secondary", @click="submit()") {{ $t('common.login') }}
			v-chip.white--text.font-weight-bold.rounded-pill(color="secondary" @click="submit()") {{ $t('common.login') }}

	v-card.px-5(
		v-if="isDemo"
		class="demo-info-card"
	)
		h3.text-center.mb-4 Demo-Modus
		v-row
			v-col(
				class="info"
			) Das Portal wird jede Nacht zurückgesetzt und alle Daten gelöscht!<br>Der automatische E-Mail-Versand ist in dieser Version deaktiviert.
		v-row
			v-col(
				class="italic"
			) Folgende Login-Daten können verwendet werden:
		v-row
			v-col(
				cols="5"
			) E-Mail Adresse
			v-col(
				cols="3"
			) Password
			v-col(
				cols="4"
			) Rolle
		v-row(
			v-for="item of demoCredentials"
			:key="item.email"
			class="table-row"
		)
			v-col(
				class="table-col"
				cols="5"
			) {{ item.email }}
			v-col(
				class="table-col"
				cols="3"
			) {{ item.password }}
			v-col(
				class="table-col"
				cols="4"
			) {{ item.role }}
</template>

<script>
import Configuration from '@/customModules/libraries/configuration.js';

export default
{
	name: 'Login',
	data: () => ({
		logo: require('@/assets/logo_colored.png'),
		passwordVisible: false,

		userEmail: process.env.NODE_ENV === 'development' ? process.env.VUE_APP_ADMIN_EMAIL : '',
		userPassword: process.env.NODE_ENV === 'development' ? process.env.VUE_APP_ADMIN_PASSWORD : '',
		isDemo: Configuration.getEnvironmentalValue('isDemo') || false,
		demoCredentials:
		[
			{ email: 'admin@gb-demo.de', password: 'demo', role: 'Administrator' },
			{ email: 'mustermann@gb-demo.de', password: 'demo', role: 'Redner' },
			{ email: 'musterfrau@gb-demo.de', password: 'demo', role: 'Redner' },
			{ email: 'event.admin@gb-demo.de', password: 'demo', role: 'Event-Administrator' },
		]
	}),
	methods: {
		submit ()
		{
			if (!this.$refs.form.validate()) return false;

			this.$store.dispatch('user/login', {
				data: {
					email: this.userEmail,
					password: this.userPassword,
				},
				request: {
					path: 'authenticate',
					options: {
					},
				},
			});
		},
	},
}
</script>

<style lang="scss" scoped>
.v-application .info
{
	background-color: var(--v-error-base) !important;
	border-color: var(--v-error-base) !important;
	color: white;
}
.table-row
{
	margin-top: 0;
}
.table-col
{
	padding-top: 5px;
	padding-bottom: 5px;
	font-size: small;

	@media screen and (max-width: 512px)
	{
		font-size: x-small;
	}
}
.italic
{
	font-style: italic;
	padding-bottom: 0;
	font-size: smaller;
}
.demo-info-card
{
	padding-top: 20px;
	padding-bottom: 40px;

	h3
	{
		padding-bottom: 20px;
	}

	background-color: rgba(220, 220, 220, 0.5);
	margin-top: 20px;
}
</style>